import useSWR from "swr";
import { Badge } from "@/components/ui/badge";
import { PageHeader } from "@/components/AppShell";
import { fetcher } from "@/lib/api";

const STATE = {
  pending: { label: "Programado", variant: "secondary" },
  sent: { label: "Enviado", variant: "default" },
  error: { label: "Error", variant: "destructive" },
};

export default function Difusion() {
  const { data } = useSWR("/broadcasts", fetcher, { refreshInterval: 15000 });

  return (
    <div>
      <PageHeader
        kicker="Canales de difusión"
        title="WhatsApp y Telegram"
        description="Registro de mensajes enviados y programados. Los mensajes con la misma hora se agrupan en un solo envío."
      />
      <div className="border border-border bg-card divide-y divide-border" data-testid="broadcasts-list">
        {(data || []).map((b) => (
          <div key={b.id} className="p-5 flex flex-col md:flex-row gap-3 justify-between">
            <div className="min-w-0">
              <div className="flex items-center gap-2 mb-1">
                <span className="kicker">{b.channel}</span>
                <Badge variant={STATE[b.status]?.variant}>{STATE[b.status]?.label || b.status}</Badge>
                {b.batched > 1 && <span className="text-xs text-muted-foreground">{b.batched} agrupados</span>}
              </div>
              <p className="text-sm whitespace-pre-line line-clamp-3">{b.text}</p>
              {b.error && <p className="text-xs text-destructive mt-1">{b.error}</p>}
            </div>
            <div className="text-xs text-muted-foreground mono shrink-0">
              {(b.sent_at || b.send_at || b.created_at || "").slice(0, 16).replace("T", " ")}
            </div>
          </div>
        ))}
        {data?.length === 0 && (
          <p className="text-sm text-muted-foreground p-8 text-center">
            Aún no se han enviado difusiones. Genere una noticia y use la pestaña «Redes y mensajería».
          </p>
        )}
      </div>
    </div>
  );
}
